export class Geocerca {
    id: string;
    name: string;
    color: string;
    active: boolean = true;
    load: boolean = false;
    unload: boolean = false;
    points: {lat: number, lng: number}[] = [];
}
